import {Component, input, OnInit, output} from '@angular/core';
import {ProjectStepRichTextService} from '../../../../../../../shared/services/project-step-rich-text.service';
import {ProjectBaseStepComponent} from '../../../../project-base-step/project-base-step.component';
import {TabStatus} from '../../../../../../../shared/tabs/tab-status.model';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {ProposalGuidancePreviewComponent} from './proposal-guidance-preview/proposal-guidance-preview.component';
import {TrustedTextPreviewComponent} from '../../../../../../../shared/components/text/text-preview/trusted-text-preview.component';

@Component({
  selector: 'app-step-8-2-4-rfq-proposal-document-guidance',
  providers: [ProjectStepRichTextService],
  imports: [LoadingComponent, ProposalGuidancePreviewComponent, TrustedTextPreviewComponent],
  templateUrl: './step-8-2-4-proposal-document-guidance.component.html',
})
export class Step824ProposalDocumentGuidanceComponent
  extends ProjectBaseStepComponent
  implements OnInit
{
  readonly stepLocked = input<boolean>(false);
  readonly statusChange = output<TabStatus>();

  override ngOnInit() {
    this.isLoadingState.set(true);
    super.ngOnInit();

    // void this.loadData();
    this.isLoadingState.set(false);
  }
}
